import { eventSender } from 'Lib/event-sender/event-sender';

$('.read-also__item').on('click', function () {
    eventSender.clickYM('click_read_also_right_sidebar', $(this).attr('href'));
});